import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MoveIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("polyline", {
    points: "14.49 5.55 11.99 3 9.51 5.5",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "11.99",
    y1: "9",
    x2: "11.99",
    y2: "4.6",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "14.49 18.45 11.99 21 9.51 18.5",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "11.99",
    y1: "15",
    x2: "11.99",
    y2: "19.4",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "5.55 9.51 3 12.01 5.5 14.49",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "9",
    y1: "12.01",
    x2: "4.6",
    y2: "12.01",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "18.45 9.51 21 12.01 18.5 14.49",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "15",
    y1: "12.01",
    x2: "19.4",
    y2: "12.01",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })]
}), 'MoveIcon');